export default "__VITE_ASSET__B97oxpFH__"